import React from 'react';
import OptionSelector from 'components/OptionSelector/OptionSelector';
import { OptionSelectorListProps } from './OptionSelectorListProps';

const formatOptionGroupName = (optionGroupName: string): string => {
  if (!optionGroupName) return '';

  const specialWordsPattern = /\b(months|years|in cms|ins)\b/gi;
  const formattedOptionGroupName = optionGroupName
    .split('_')
    .join(' ')
    .replace(specialWordsPattern, (match) => `(${match})`);

  return formattedOptionGroupName;
};

function OptionSelectorList({ skus, features }: OptionSelectorListProps) {
  return (
    <div data-testid="multiple-option-selector">
      {features?.map(({ name }) => (
        <OptionSelector key={name} skus={skus} formattedName={formatOptionGroupName(name)} name={name} />
      ))}
    </div>
  );
}

export default OptionSelectorList;
